<template>
  <li class="org-unit">
    <div class="d-flex align-items-center py-25" :style="{ paddingLeft: `${depth * 18}px` }">
      <b-button
        v-if="node.children.length"
        size="sm"
        variant="flat-secondary"
        class="p-0 mr-50"
        style="width: 22px"
        @click="open = !open"
      >
        <feather-icon :icon="open ? 'ChevronDownIcon' : 'ChevronRightIcon'" size="16" />
      </b-button>
      <span v-else class="mr-50" style="width: 22px; display: inline-block" />

      <b-badge :variant="levelVariant" class="mr-50 text-capitalize">{{ label }}</b-badge>
      <span :class="{ 'text-muted': !node.is_active }">{{ node.title }}</span>
      <small v-if="node.code" class="text-muted ml-1">{{ node.code }}</small>
      <small v-if="!node.is_active" class="text-warning ml-1">inactive</small>
      <small v-if="node.children.length" class="text-muted ml-1">({{ node.children.length }})</small>
    </div>
    <ul v-if="open && node.children.length" class="list-unstyled mb-0">
      <org-unit-node v-for="child in node.children" :key="child.id" :node="child" :depth="depth + 1" :expand="expand" />
    </ul>
  </li>
</template>

<script>
import { BBadge, BButton } from "bootstrap-vue";

const LEVELS = {
  head_office: { label: "Head Office", variant: "light-primary" },
  nation: { label: "Nation", variant: "light-primary" },
  region: { label: "Region", variant: "light-info" },
  area: { label: "Area", variant: "light-success" },
  district: { label: "District", variant: "light-warning" },
  assembly: { label: "Assembly", variant: "light-secondary" },
  department: { label: "Department", variant: "light-dark" },
};

export default {
  name: "OrgUnitNode",
  components: { BBadge, BButton },
  props: {
    node: { type: Object, required: true },
    depth: { type: Number, default: 0 },
    expand: { type: Boolean, default: false },
  },
  data() {
    // Head Office and the nations start open, so each nation's regions are visible at once
    return { open: this.expand || this.depth < 2 };
  },
  computed: {
    label() {
      return (LEVELS[this.node.level] || {}).label || this.node.level;
    },
    levelVariant() {
      return (LEVELS[this.node.level] || {}).variant || "light-secondary";
    },
  },
  watch: {
    expand(value) {
      this.open = value || this.depth < 2;
    },
  },
};
</script>
